import { Bulb } from '@quizzach/assets';
import { Colors } from '@quizzach/styles';
import { QuestionText } from '@quizzach/play-styles';
import { useWindowListener } from '@quizzach/contexts';
import { useTranslation } from 'react-i18next';

export const Explanation = ({
	explanation,
	onShowExplanation,
}: {
	explanation?: string;
	onShowExplanation: () => void;
}) => {
	const { t } = useTranslation();
	const { touchDevice } = useWindowListener();

	if (!explanation) return null;

	return explanation.length < 180 ? (
		<QuestionText style={{ margin: 0 }} $small>
			<div
				className='answer-text'
				dangerouslySetInnerHTML={{
					__html: explanation || '',
				}}
			/>
		</QuestionText>
	) : (
		<div className='answer-explanation' onClick={onShowExplanation}>
			<Bulb color={Colors.textStrong} size={touchDevice ? 17 : 30} />
			<QuestionText style={{ margin: 0 }} $extraSmall>
				<div className='answer-text' style={{ marginLeft: '10px' }}>
					{t('quiz.explanation.clickForMore')}
				</div>
			</QuestionText>
		</div>
	);
};
